/** Возвращает стандартные HTTP-заголовки для JSON-запросов
 * @returns {{ "X-CSRF-Token": string, "Content-Type": string }}
 */
export function getRequestHeaders() {
  return {
    "X-CSRF-Token": getMeta("csrf-token"),
    "Content-Type": "application/json",
  };
}
